module.exports = __webpack_public_path__ + "img/idi.6c3fa3e1.png";